export default __webpack_public_path__ + "static/media/paymaya.21107bd8.png";